module.exports = __webpack_public_path__ + "media/valentines_tipping_tier_4-ec0ee266e027b4661991900b8c7efdd3.mp3";